var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.areFiveCardHandPercentagesUpToDate && _vm.textWhenFiveCardHandPercentagesArentUpToDate)?_c('section',{staticClass:"five-card-hands-section-alerts bg-warning"},[_vm._v("\n  "+_vm._s(_vm.textWhenFiveCardHandPercentagesArentUpToDate)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df06f998","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/five-card-hands-section/alerts.vue
// module id = onxA
// module chunks = 0